import React from 'react';
import Spinner from '../../../components/Spinner';
import './ClientLoader.css';

interface ClientLoaderProps {
  label?: string;
}

const DEFAULT_LABEL = '\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430';

const ClientLoader: React.FC<ClientLoaderProps> = ({ label = DEFAULT_LABEL }) => {
  return (
    <div className="client-loader">
      <div className="client-loader__panel">
        <Spinner className="client-loader__visual" />
        <span className="client-loader__label">{label}</span>
      </div>
    </div>
  );
};

export default ClientLoader;
